
<template>
  <section class="container-fluid">
    <CRow>
      <CCol md="12">
        <CCard>
          <CCardHeader>
            <slot name="header">
              <div class="row">
                <div class="col-12 col-xl-7">
                  <CIcon name="cil-grid" />Calificaciones de cursos por periodo
                </div>
                <div class="col-12 col-xl-5">
                  <div class="row">
                    <div class="col-12 col-xl-3">
                      <div class="form-group">
                        <label class="control-label" for="courses_offered_year"
                          >Gestión:</label
                        >
                        <b-form-select
                          v-model="columnFilter.courses_offered_year"
                          :options="coursesOfferedYearsOptions"
                          id="courses_offered_year"
                          size="sm"
                        >
                        </b-form-select>
                      </div>
                    </div>
                    <div class="col-12 col-xl-3">
                      <div class="form-group">
                        <label class="control-label" for="period"
                          >Periodo:</label
                        >
                        <b-form-select
                          v-model="columnFilter.period"
                          :options="periodOptions"
                          value-field="value"
                          text-field="name"
                          id="period"
                          size="sm"
                        >
                        </b-form-select>
                      </div>
                    </div>
                    <!-- Pénsum -->
                    <div class="col-12 col-xl-5">
                      <div class="form-group required">
                        <label class="control-label" for="syllabus_id"
                          >Pénsum</label
                        >
                        <b-form-select
                          v-model="columnFilter.syllabus_id"
                          :options="syllabusOptions"
                          value-field="id"
                          text-field="description"
                          id="syllabus_id"
                          size="sm"
                        >
                          <b-form-select-option :value="null"
                            >--Seleccione un pénsum--</b-form-select-option
                          >
                        </b-form-select>
                      </div>
                    </div>
                    <div class="col-12 col-xl-1 ">
                      <button
                        @click="print()"
                        title="Reporte de venta"
                        class="btn btn-secondary btn-sm mt-3 float-right"
                        type="button"
                      >
                        <span><CIcon size="sm" name="cil-print" /></span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </slot>
          </CCardHeader>
        </CCard>
      </CCol>
    </CRow>
  </section>
</template>
<script>
import {
  BAlert,
  BModal,
  BButton,
  BButtonGroup,
  BFormSelect,
  BFormSelectOption,
} from "bootstrap-vue";

import TableRecords from "@/components/shared/TableRecords";
import { Utils } from "@/plugins/utils";
import Constants from "@/plugins/constants";
import Syllabus from "@/plugins/services/syllabus";

export default {
  name: "StatisticsByPeriodsList",
  components: {
    BAlert,
    BModal,
    BButton,
    BButtonGroup,
    BFormSelect,
    BFormSelectOption,
    TableRecords,
  },
  data() {
    return {
      columnFilter: {
        period: 1,
        column: null,
        asc: false,
        enabled: true,
        syllabus_id: null,
      },
      coursesOfferedYearsOptions: [],
      syllabusOptions: [],
      periodOptions: Constants.periodOptions2,
      page: 0,
      pages: 0,
      limit: 20,
      from: 0,
      to: 0,
      total: 0,
      loading: true,
      dataEmit: { modalShow: false, data: null },
    };
  },
  mounted() {
    this.columnFilter.courses_offered_year = Utils.getYear(this.userAuth.now);
    this.getCoursesOfferedYears();
    this.getSyllabus();
  },
  computed: {
    userAuth() {
      return this.$store.state.userAuth;
    },
  },
  methods: {
    getCoursesOfferedYears() {
      this.coursesOfferedYearsOptions = Utils.getYears2(this.userAuth.now);
    },
    getSyllabus() {
      Syllabus.selectAll({ enabled: true })
        .then((res) => {
          this.syllabusOptions = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    print() {
      let cFilter = this.columnFilter;
      let querystring = Utils.encodeQueryData(cFilter);
      let teacherSchedule = `${process.env.MIX_APP_API_ENDPOINT}/courses-offered/statistics-by-period-pdf?${querystring}`;
      window.open(teacherSchedule, "_blank");
    },
  },
};
</script>
